import { useEffect, useState } from 'react';
import { subMonths } from 'date-fns';
import { getCrmChartsData } from '../../../../services/api';
import { LineConfig, prepareChartData, TransformedDataPoint } from '../helpers/prepareChartData';
import { startOfDay, endOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';

type CrmChartsDbData = {
  actions: {
    actionId: number;
    colorCode: string;
    count: number;
    name: string;
    reasons: { reason: string; count: number }[];
  }[];
  date: string;
};

export const useCrmChartsData = () => {
  const { t } = useTranslation();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [chartsData, setChartsData] = useState<TransformedDataPoint[] | null>(null);
  const [chartsLines, setChartsLines] = useState<LineConfig[] | null>(null);

  const fetchData = async (from: string, to: string) => {
    console.log('Fetching data with from:', from, 'to:', to);
    setLoading(true);
    setError(null);
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const rawData: CrmChartsDbData[] = await getCrmChartsData(from, to, timezone);
      console.log('Fetched data:', rawData);
      const { data, lines } = prepareChartData(rawData);
      // localize line names so chart component receives translated labels
      const localizedLines = lines.map((l) => ({
        ...l,
        name: t(`global.selectorStatus.${l.name}`, { defaultValue: l.name }),
      }));
      setChartsData(data);
      setChartsLines(localizedLines);
    } catch (err) {
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTo(new Date().toISOString().split('T')[0]); // Set default to date to today
    const monthAgo = subMonths(new Date(), 1).toISOString().split('T')[0];
    setFrom(monthAgo);
    fetchData(monthAgo, new Date().toISOString().split('T')[0]);
  }, []);

  return {
    from,
    setFrom,
    to,
    setTo,
    error,
    setError,
    chartsData,
    loading,
    setLoading,
    fetchData,
    chartsLines,
  };
};
